'use client'

import { motion } from "framer-motion"
import { useState } from 'react'

const steps = [
  {
    title: "Register",
    description: "Login or create a new account",
    icon: "👤"
  },
  {
    title: "Quick Pick",
    description: "Select your sources of income",
    icon: "📋"
  },
  {
    title: "Pre-filled Data",
    description: "Details auto extracted from IT dept for ITR filing",
    icon: "📄"
  },
  {
    title: "Compare",
    description: "Choose between old & new regimes",
    icon: "⚖️"
  },
  {
    title: "File ITR",
    description: "E-file income tax & get confirmation from IT dept",
    icon: "✅"
  }
]

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.3
    }
  }
}

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 50
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 12
    }
  }
}

const progressVariants = {
  hidden: { width: 0 },
  visible: { 
    width: "100%",
    transition: { duration: 0.5, ease: "easeInOut" }
  }
}

export default function EnhancedSimpleStep() {
  const [hoveredStep, setHoveredStep] = useState(null)

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-50 to-cyan-100 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="text-center mb-16"
        >
          <motion.h1 
            variants={itemVariants}
            className="text-4xl md:text-5xl font-bold text-cyan-900 mb-4"
          >
            5 Simple Steps to e-file your
          </motion.h1>
          <motion.h2 
            variants={itemVariants}
            className="text-3xl md:text-4xl font-bold text-cyan-600"
          >
            Income Tax Return
          </motion.h2>
        </motion.div>

        <motion.div 
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="relative grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-4"
        >
          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              variants={itemVariants}
              className="relative z-10"
              onMouseEnter={() => setHoveredStep(index)}
              onMouseLeave={() => setHoveredStep(null)}
            >
              <motion.div
                className="bg-white rounded-xl shadow-md p-6 h-full hover:shadow-xl transition-shadow duration-300 border-2 border-transparent hover:border-cyan-300"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300, damping: 10 }}
              >
                <div className="flex flex-col items-center h-full">
                  <motion.div 
                    className="w-20 h-20 bg-cyan-100 rounded-full flex items-center justify-center mb-4 text-3xl"
                    whileHover={{ rotate: 360 }}
                    transition={{ duration: 0.5 }}
                  >
                    {step.icon}
                  </motion.div>
                  <h3 className="text-xl font-semibold text-cyan-800 mb-2 text-center">
                    {step.title}
                  </h3>
                  <p className="text-cyan-600 text-center text-sm flex-grow">
                    {step.description}
                  </p>
                  <motion.div
                    className="absolute bottom-0 left-0 right-0 h-1 bg-cyan-500 rounded-b-xl"
                    initial={{ scaleX: 0 }}
                    animate={{ scaleX: hoveredStep === index ? 1 : 0 }}
                    transition={{ duration: 0.3 }}
                  />
                </div>
              </motion.div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 w-6 h-6">
                  <motion.div
                    className="w-full h-0.5 bg-cyan-300"
                    variants={progressVariants}
                  />
                </div>
              )}
            </motion.div>
          ))}
        </motion.div>

        {/* <motion.div
          variants={itemVariants}
          className="mt-16 text-center"
        >
          <a
            href="#start-filing"
            className="inline-block bg-gradient-to-r from-cyan-500 to-cyan-600 text-white font-bold py-3 px-8 rounded-full hover:from-cyan-600 hover:to-cyan-700 transition duration-300 shadow-md hover:shadow-lg text-lg"
          >
            Start Filing Now
          </a>
        </motion.div> */}
      </div>
    </div>
  )
}

